var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _g3, _path8, _path9, _path10, _path11, _g4, _path12, _path13, _path14, _path15, _g5, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 33,
    viewBox: "0 0 110 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_227_109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.619141 0.374512H109.545V32.4196H0.619141V0.374512Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_227_109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.742 32.0135H4.7303C2.68324 32.0135 1.02441 30.3547 1.02441 28.3096V4.37825C1.02441 2.33315 2.68324 0.672363 4.7303 0.672363H105.742C107.789 0.672363 109.448 2.33315 109.448 4.37825V28.3096C109.448 30.3547 107.789 32.0135 105.742 32.0135Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_227_109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 110,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.619141 -0.127441H109.851V32.4196H0.619141V-0.127441Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_227_109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.72894 1.07836C2.90934 1.07836 1.42894 2.55875 1.42894 4.37836V28.3097C1.42894 30.1293 2.90934 31.6078 4.72894 31.6078H105.743C107.562 31.6078 109.043 30.1293 109.043 28.3097V4.37836C109.043 2.55875 107.562 1.07836 105.743 1.07836H4.72894ZM105.743 32.4195H4.72894C2.46228 32.4195 0.619141 30.5764 0.619141 28.3097V4.37836C0.619141 2.11169 2.46228 0.268555 4.72894 0.268555H105.743C108.009 0.268555 109.852 2.11169 109.852 4.37836V28.3097C109.852 30.5764 108.009 32.4195 105.743 32.4195Z",
    fill: "#A7A9AB"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0477 24.5096H88.5535V14.4174H87.0477V24.5096ZM100.616 18.0527L98.8888 22.4292H98.8379L97.0457 18.0527H95.4222L98.1104 24.1684L96.5771 27.5704H98.1496L102.291 18.0527H100.616ZM92.0712 23.3625C91.579 23.3625 90.8908 23.1174 90.8908 22.5057C90.8908 21.7272 91.7477 21.4292 92.4869 21.4292C93.1496 21.4292 93.4614 21.5723 93.8633 21.7665C93.7457 22.7018 92.9418 23.3625 92.0712 23.3625ZM92.2535 17.8331C91.1633 17.8331 90.0339 18.3135 89.5653 19.3782L90.9026 19.9351C91.1888 19.3782 91.7202 19.1959 92.279 19.1959C93.0594 19.1959 93.8496 19.6625 93.8633 20.4939V20.5978C93.5908 20.4429 93.0065 20.2076 92.2928 20.2076C90.8516 20.2076 89.3849 20.9998 89.3849 22.4802C89.3849 23.8312 90.5653 24.7018 91.8908 24.7018C92.9026 24.7018 93.4614 24.2469 93.8124 23.7135H93.8633V24.4939H95.3182V20.6233C95.3182 18.8331 93.981 17.8331 92.2535 17.8331ZM82.9437 19.2821H80.8006V15.8214H82.9437C84.0712 15.8214 84.7084 16.7547 84.7084 17.5508C84.7084 18.3351 84.0712 19.2821 82.9437 19.2821ZM82.9045 14.4174H79.2947V24.5096H80.8006V20.6861H82.9045C84.5751 20.6861 86.2163 19.4763 86.2163 17.5508C86.2163 15.6253 84.5751 14.4174 82.9045 14.4174ZM63.2222 23.3645C62.181 23.3645 61.3084 22.4939 61.3084 21.2978C61.3084 20.088 62.181 19.2037 63.2222 19.2037C64.2496 19.2037 65.0555 20.088 65.0555 21.2978C65.0555 22.4939 64.2496 23.3645 63.2222 23.3645ZM64.9496 18.6174H64.8986C64.5614 18.2155 63.9104 17.8508 63.0908 17.8508C61.3731 17.8508 59.8006 19.3606 59.8006 21.2978C59.8006 23.2233 61.3731 24.7194 63.0908 24.7194C63.9104 24.7194 64.5614 24.3547 64.8986 23.939H64.9496V24.4312C64.9496 25.7449 64.2496 26.4488 63.1163 26.4488C62.1928 26.4488 61.6202 25.7841 61.3869 25.2253L60.0731 25.7723C60.4496 26.6821 61.4516 27.7998 63.1163 27.7998C64.8849 27.7998 66.381 26.7606 66.381 24.2233V18.0586H64.9496V18.6174ZM67.4222 24.5096H68.932V14.4174H67.4222V24.5096ZM71.1555 21.1802C71.1163 19.8527 72.183 19.1782 72.9496 19.1782C73.5477 19.1782 74.0555 19.4763 74.2241 19.9057L71.1555 21.1802ZM75.8379 20.0351C75.5516 19.2684 74.681 17.8508 72.8967 17.8508C71.13 17.8508 69.6594 19.2429 69.6594 21.2841C69.6594 23.2096 71.1163 24.7194 73.0673 24.7194C74.6418 24.7194 75.5516 23.7567 75.9281 23.1959L74.7575 22.4155C74.3673 22.988 73.8339 23.3645 73.0673 23.3645C72.3006 23.3645 71.7535 23.0155 71.4026 22.3253L75.9928 20.4272L75.8379 20.0351ZM39.2575 18.9037V20.3606H42.7437C42.6398 21.1802 42.3673 21.7782 41.9496 22.1939C41.4437 22.7018 40.6496 23.2606 39.2575 23.2606C37.1124 23.2606 35.4339 21.5312 35.4339 19.3861C35.4339 17.239 37.1124 15.5096 39.2575 15.5096C40.4163 15.5096 41.2614 15.9645 41.8849 16.5508L42.9124 15.5214C42.0418 14.69 40.8849 14.0527 39.2575 14.0527C36.3182 14.0527 33.8477 16.4469 33.8477 19.3861C33.8477 22.3253 36.3182 24.7194 39.2575 24.7194C40.8457 24.7194 42.0418 24.1978 42.979 23.2233C43.9398 22.2606 44.2398 20.9076 44.2398 19.8155C44.2398 19.4763 44.2143 19.1645 44.1614 18.9037H39.2575ZM48.2026 23.3645C47.1614 23.3645 46.2653 22.5076 46.2653 21.2841C46.2653 20.0488 47.1614 19.2037 48.2026 19.2037C49.2437 19.2037 50.1398 20.0488 50.1398 21.2841C50.1398 22.5076 49.2437 23.3645 48.2026 23.3645ZM48.2026 17.8508C46.3026 17.8508 44.7555 19.2939 44.7555 21.2841C44.7555 23.2606 46.3026 24.7194 48.2026 24.7194C50.1026 24.7194 51.6496 23.2606 51.6496 21.2841C51.6496 19.2939 50.1026 17.8508 48.2026 17.8508ZM55.7222 23.3645C54.681 23.3645 53.783 22.5076 53.783 21.2841C53.783 20.0488 54.681 19.2037 55.7222 19.2037C56.7614 19.2037 57.6594 20.0488 57.6594 21.2841C57.6594 22.5076 56.7614 23.3645 55.7222 23.3645ZM55.7222 17.8508C53.8222 17.8508 52.2751 19.2939 52.2751 21.2841C52.2751 23.2606 53.8222 24.7194 55.7222 24.7194C57.6202 24.7194 59.1692 23.2606 59.1692 21.2841C59.1692 19.2939 57.6202 17.8508 55.7222 17.8508Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13818 6.38402C8.90289 6.63108 8.76367 7.01735 8.76367 7.51735V25.3566C8.76367 25.8566 8.90289 26.2428 9.13818 26.4899L9.19701 26.5487L19.1911 16.5546V16.3193L9.19701 6.3252",
    fill: "#59C9F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_227_109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 12,
    width: 9,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1895 12.9941H27.2208V19.9216H19.1895V12.9941Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_227_109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_227_109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 12,
    width: 9,
    height: 8
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1885 16.3177V16.555L22.5198 19.8883L22.5944 19.8432L26.5414 17.602C27.6689 16.9608 27.6689 15.9138 26.5414 15.2726L22.5963 13.0295L22.5198 12.9863L19.1885 16.3177Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_227_109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_227_109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 12,
    width: 9,
    height: 8
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1875 16.3177V16.555L22.5189 19.8883L22.5934 19.8432L26.5404 17.602C27.6679 16.9608 27.6679 15.9138 26.5404 15.2726L22.5953 13.0295L22.5189 12.9863L19.1875 16.3177Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_227_109)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.28235,
    height: 6.92706,
    transform: "matrix(1 0 0 -1 19.1377 19.9209)",
    fill: "url(#pattern0)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_227_109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 16,
    width: 14,
    height: 11
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15137 16.437H22.7043V26.9782H9.15137V16.437Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_227_109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_227_109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 16,
    width: 14,
    height: 11
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1377 26.49C9.50828 26.8841 10.122 26.9311 10.8142 26.539L22.5965 19.8429L19.1906 16.437L9.1377 26.49Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_227_109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_227_109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 16,
    width: 14,
    height: 11
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1377 26.49C9.50828 26.8841 10.122 26.9311 10.8142 26.539L22.5965 19.8429L19.1906 16.437L9.1377 26.49Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_227_109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_227_109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 9,
    width: 25,
    height: 25
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0082 11.5507L3.90625 21.6526L15.8533 33.5997L25.9553 23.4958L14.0082 11.5507ZM15.8533 9.70557L14.0082 11.5507L25.9553 23.4958L27.7984 21.6526L15.8533 9.70557Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_227_109)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5027,
    height: 10.3906,
    transform: "matrix(1 0 0 -1 9.10059 26.8477)",
    fill: "url(#pattern1)"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_227_109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 5,
    width: 14,
    height: 12
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15137 5.89648H22.7043V16.4377H9.15137V5.89648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_227_109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_227_109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 6,
    width: 14,
    height: 11
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1377 6.3826L19.1906 16.4375L22.5985 13.0297L10.8142 6.33358C10.4887 6.14926 10.1828 6.06299 9.91024 6.06299C9.60044 6.06299 9.33377 6.17475 9.1377 6.3826Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_227_109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_227_109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 6,
    width: 14,
    height: 11
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1377 6.3826L19.1906 16.4375L22.5985 13.0297L10.8142 6.33358C10.4887 6.14926 10.1828 6.06299 9.91024 6.06299C9.60044 6.06299 9.33377 6.17475 9.1377 6.3826Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_227_109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_227_109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: -1,
    width: 25,
    height: 25
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 11.263L10.5357 17.8924L22.4827 5.94729L15.8513 -0.684082L3.90625 11.263ZM10.5357 17.8924L15.8513 23.2081L27.7984 11.263L22.4827 5.94729L10.5357 17.8924Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_227_109)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5027,
    height: 10.3906,
    transform: "matrix(1 0 0 -1 9.10059 16.4575)",
    fill: "url(#pattern2)"
  })))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7258 6.95481C37.4218 6.68618 37.0238 6.51364 36.5807 6.51364C35.5885 6.51364 34.8238 7.33324 34.8238 8.33913C34.8238 9.34697 35.5885 10.1587 36.5807 10.1587C37.4356 10.1587 38.0571 9.66266 38.0983 8.87638H36.7473V8.31952H38.8277C38.8277 9.98815 37.9395 10.7725 36.5807 10.7725C35.2297 10.7725 34.1826 9.68422 34.1826 8.33913C34.1826 6.98815 35.2297 5.89795 36.5807 5.89795C37.2081 5.89795 37.7728 6.14109 38.1865 6.5254",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5188 5.95459V6.55263H40.3463V8.07028H42.2423V8.67028H40.3463V10.1036H42.5874V10.7036H39.7051V5.95459",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6749 5.95459V6.56047H45.2337V10.7036H44.5867V6.56047H43.1455V5.95459",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1084 10.7036H49.7496V5.95459H49.1084V10.7036Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1222 5.95459V6.56047H52.681V10.7036H52.032V6.56047H50.5908V5.95459",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6441 10.1529C59.6441 10.1529 60.4088 9.34697 60.4088 8.33913C60.4088 7.33324 59.6441 6.51952 58.6441 6.51952C57.652 6.51952 56.8873 7.33324 56.8873 8.33913C56.8873 9.34697 57.652 10.1529 58.6441 10.1529ZM58.6441 5.89795C60.003 5.89795 61.0579 6.98815 61.0579 8.33913C61.0579 9.68422 60.003 10.7725 58.6441 10.7725C57.2932 10.7725 56.2461 9.68422 56.2461 8.33913C56.2461 6.98815 57.2932 5.89795 58.6441 5.89795Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8498 10.7036L62.6851 7.12714V10.7036H62.0439V5.95459H62.6792L64.8224 9.50361V5.95459H65.4636V10.7036",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_227_109",
    transform: "scale(0.00606061 0.00724638)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_227_109",
    transform: "scale(0.00371747 0.00483092)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_227_109",
    transform: "scale(0.00371747 0.00483092)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109.176,
    height: 32,
    fill: "white",
    transform: "translate(0.617188 0.5)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_227_109",
    width: 165,
    height: 138,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKUAAACKCAIAAABEsx1uAAAABmJLR0QA/wD/AP+gvaeTAAABiklEQVR4nO3RQQrCMBRAwdYLeP/zeC0hXYhotRURCsKbWSWk/Ca8+Xo5T8/m9/XYP7p/sHt0247t08d6fJw/TfNYb3+45HrIxiW/GXLwS18GHuB0+B/4J3q36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLXq36N2id4veLQuvRg30apKsewAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_227_109",
    width: 269,
    height: 207,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQ0AAADPCAIAAABgJxNUAAAABmJLR0QA/wD/AP+gvaeTAAALcUlEQVR4nO3dQZqeNhCE4frnRDlRjp3rOIuZEdAqtYRXqPl6JVAXyHHex4mTNp///vlXd+qjP2211i+1yELwd/NPsje45yJd01L/qfv6znnkE1eTiPkxfbKI+2sw+RnJIq5j8Jjhz8j459P/QD5ZxkRi7+V6oT9uxMj8b+TPn69pz/WJIMkTYQUSF9oNiaQbTkAyS4QVSFxoQyRadwKSWSKsQOJCeyLRohOQzBJhBRIX2haJVpyAZJYIK5C40M5IPlMnIJklwgokLrQ5EuVOQDJLhBVIXGh/JEqcgGSWCCuQuFAJJBo5AcksEVYgcaEqSGSdgGSWCCuQuFAhJOqdgGSWCCuQuFAtJApOQDJLhBVIXKgcEp2dgGSWCCuQuFBFJGpOQDJLhBVIXKgoEn07AcksEVYgcaG6SCR9gWSWCCuQuFBpJDr+/QQk+atA8mIk0vecFkjyV4Hk3UgkfYFk8iqQvB6JPqvzJ92xQGL7j1sgSc+zFRKtzZ90xwKJ7T9ugSQ9z25IPgvzJ92xQGL7j1sgSc+zIRLN5k+6Y4HE9h+3QJKeZ08kSudPumOBxPYft0CSnmdbJBrPn3THAontP26BJD3Pzkg0mD/pjgUS23/cAkl6ns2RyM2fdMcCie0/boEkPc/+SNTNn3THAontP26BJD1PCSS6zp90xwKJ7T9ugSQ9TxUkOs2fdMcCie0/boEkPU8hJPqdP+mOBRLbf9wCSXqeWkgkfYFktf+4BZL0POWQSPoCyVL/cQsk6XkqIpHCd4JAYvuPWyBJz1MUiS6/LwwS23/cAkl6nrpItDj3CxKQuJeMrqsh0Y8TkNj+4xZI0vNUR/KZzv2CBCTuJaPrmkiUz/2CBCTuJaPrskg0mz8RSG70gyTvjxvbIFE6fyKQ3OgHSd4fN3ZCovH8iUByox8keX/c2AyJBvMnAsmNfpDk/XFjPyRy8ycCyY1+kOT9cWNLJOrmTwSSG/0gyfvjxq5IdJ0/EUhu9IMk748bGyPRaf5EILnRD5K8P27sjUS/8ycCyY1+kOT9cWN7JPr95y6QLPeDJO+PGxWQyMxpHenkHkjuR1wHSLrgE5Eozmkd6eQeSO5HXAdIuuBDkcj893iQgCRevx2JohOQgCReg0Sazv2CBCST/rhREMknn/sFCUgm/XGjJhIlc78gAcmkP26URaLR3C9IQDLpjxuVkcjO/YIEJJP+uFEcicbzJwIJSHx/3KiPRIP5E4EEJL4/brwCidz8iUACEt8fN96CRN38iUACEt8fN16ERNf5E4EEJL4/brwLiU7zJwIJSHx/3HgdEp3+/QQk9yOuAyRdcHskyua0uiRIzKlAklcJJBrOaXVJkJhTgSSvKkjk57S6JEjMqUCSVyEkGv453CAZRVwHSLpgKSTyTkAyirgOkHTBakg++dwvSMypQJJXRSRK5n5BYk4FkryKItFo7hck5lQgyasuEtm5X5CYU4Ekr9JI1M/9gsScCiR5VUeiMPcLEnMqkOT1AiS6PX9y6gaJj5xaQeJqPyT63Jo/OcVA4iOnVpC42hKJbsyfnGIg8ZFTK0hc7YpEq/MnpxhIfOTUChJXGyPR0vzJKQYSHzm1gsTV3kg0nz85xUDiI6dWkLjaHokm8yenGEh85NQKElcVkGj4/9VfYyDxkVMrSFwVQaJsTus3BhIfObWCxFUdJJr8egKSUeTUChJXpZB8MicgGUVOrSBxVQ2JkrlfkPjIqRUkrgoi0WjuFyQ+cmoFiauaSGTnfkHiI6dWkLgqi0T93C9IfOTUChJXlZEozP2CxEdOrSBxVRyJznO/IPGRUytIXNVHojb3CxIfObWCxNUrkOh77hckPnJqBYmrtyDRdf5EILGPBomrFyHR9bvYIDGPBomrdyHRrTktkEwiIEn62/M3RKL1OS2QTCIgSfrb8/dEosU5LZBMIiBJ+tvzt0Wi+fwJSKYRkCT97fk7I9F0nhEkkwhIkv72/M2RfHInIJlEQJL0t+fvj0SJE5BMIiBJ+tvzSyDRyAlIJhGQJP3t+VWQyDoBySQCkqS/Pb8QEvVOQDKJgCTpb8+vhUTBCUgmEZAk/e355ZDIf/8EJCABybW675+ABCQg6er6/ROQgAQkrr5AMomAJOlvzy+NRN13sUHiQiCx/e351ZHo+l1skLgQSGx/e/4LkOj0XWyQuBBIbH97/juQ6LM2pwWSaQQkS5G4yiLPQaKVOS2QTCMgWYrEVRZ5FBJN57RAMo2AZCkSV1nkaUg+q/Mnxy2QpOcBiY3EVRZ5IBItzZ8ct0CSngckNhJXWeSZSDSfPzlugSQ9D0hsJK6yyGORaDJ/ctwCSXoekNhIXGWRJyNRNn9y3AJJeh6Q2EhcZZGHI9Fw/uS4BZL0PCCxkbjKIs9HIj9/ctwCSXoekNhIXGWRLZDIzJ8cSZCk5wGJjcRVFtkFieL8yZEESXoekNhIXGWRjZCo+/7JdxIk6XlAYiNxlUX2QiL3XWyQpOcBiY3EVRbZDom672KDJD0PSGwkrrLIjkh0/S42SNLzgMRG4iqLbIpEp7lfkKTnAYmNxFUW2ReJfud+QZKeByQ2EldZZGskn4++QOJeMroGyfUV70Ci2/MnIMn74wZIKiDRvfkTkOT9cQMkRZDoxvwJSPL+uAGSOki0On8Ckrw/boCkFBItzZ+AJO+PGyCphkTz+ROQ5P1xAyQFkWgyfwKSvD9ugKQmEmXzJyDJ++MGSMoi0XD+BCR5f9wASWUk8vMnIMn74wZIiiOR+31hkKT9cQMk9ZGocwKStD9ugOQVSHR1ApK0P26A5C1IdHICkrQ/boDkRUik8J0gkNj+uAGSdyHR5TtBILH9cQMkr0Oi7nu/g5NcCiQL/UcHSNLaAYmu3/sdnORSIFnoPzpAktYmSHT63u/gJJcCyUL/0QGStPZBor+Z03IdIOmCIElrKyS6PaflOkDSBUGS1m5IdG9Oy3WApAuCJK0NkejGnJbrAEkXBElaeyLR6pyW6wBJFwRJWtsi0dKclusASRcESVo7I9F8TuvntcnVIHJqBYkrkCzUM5BoMqf189rkahA5tYLEFUgW6jFIlM1p/bw2uRpETq0gcQWShXoSEg3ntH5em1wNIqdWkLgCyUI9DIn8nNbPa5OrQeTUChJXIFmo5yGRmdP6eW1y1Qoky/3tLSBZCj4LieKc1s9rk6tWIFnub28ByVLwcUh0mdP6eW1y1Qoky/3tLSBZCj4Ribrv/SZXrUCy3N/eApKl4EOR6Pq93+shfD9IlvvbW0CyFHwuEo3mfkHSBUGSVmkksnO/IOmCIEmrOhL1c78g6YIgSesFSLQwfyKQ3OhvbwHJUnAPJJrNnwgkN/rbW0CyFNwGidL5E4HkRn97C0iWgjsh0Xj+RCC50d/eApKl4GZINJg/EUhu9Le3gGQpuB8SDf78LpAs97e3gGQpuCUSzee0vgskwwLJQm2ORJM5re8CybBAslD7I1E2p/VdIBkWSBaqBBIN57S+CyTDAslCVUEiP6f1XSAZFkgW6q+QPLa6Oa3vAsmwQLJQf4vkmb+YyP++MEiGBZKFKodExglIhgWShaqIRHbuFySuQLJQRZGon/sFiSuQLFRdJApzvyBxBZKFKo1E57lfkLgCyUJVR6I29wsSVyBZqBcgUTp/IpCAZFLvQKLx/IlAApJJvQaJRt+PBwlIJvUmJLoxpwWSpL89HyR5bk8kWp3TAknS354Pkjy3LRItzWmBJOlvzwdJntsZieZzWiBJ+tvzQZLnNkeiyZwWSJL+9nyQ5Ln9kSib0wJJ0t+eD5I8VwKJhnNaIEn62/NBkueqINHov5+AZNjfng+SPFcIiawTkAz72/NBkudqIVHvBCTD/vZ8kOS5ckhkvn8CEtvfng+SPFcRieL3T0Bi+9vzQZLniiKR9D/kIkJzF+43qAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_227_109",
    width: 269,
    height: 207,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayLogo);
export default __webpack_public_path__ + "static/media/google-play-logo.efbcf56f05b8f6dd6e89c3b96775231e.svg";
export { ForwardRef as ReactComponent };